export default (theme) => ({
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
        gap: 20,
        '& > *': {
            margin: 0,
        },
        '& ol, & ul': {
            margin: 0,
            paddingLeft: 24,
        },
        '& ol': {
            listStyle: 'decimal',
        },
        '& ul': {
            listStyle: 'disc',
        },
        '& li': {
            display: 'list-item',
        },
        '& li::marker': {
            color: 'inherit',
        },
    },
    block: {
        display: 'block',
    },
});
